import type { Entry } from 'contentful';

/**
 * Checks if the given entry supports a `locales` field.
 *
 * @param entry The entry to use.
 */
export function supportsLocales<TEntryType = unknown>(
  entry: Entry<TEntryType>
): entry is Entry<
  TEntryType & {
    locales?: string[] | undefined;
  }
> {
  return (
    typeof entry.fields === 'object' &&
    entry.fields != null &&
    'locales' in entry.fields
  );
}
